// extracted by mini-css-extract-plugin
export default {"layout1BoxH5":"TxOZ1v6RrtK6SNKSEukb","common_bganimation":"m4hXadiMlKBiCJ4HDfKN"};